import { makeStyles } from '@mui/styles';
import IconButton from 'apollo-react/components/IconButton';
import TextField from 'apollo-react/components/TextField';
import Tooltip from 'apollo-react/components/Tooltip';
import { EllipsisHorizontal } from 'apollo-react-icons';
import SearchIcon from 'apollo-react-icons/Search';
import Trash from 'apollo-react-icons/Trash';
import React, { useEffect, useState } from 'react';

import { getUITA } from '../../../../../utils/commonUtils';

const useStyles = makeStyles({
  field: {
    margin: 0,
  },
  input: {
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  popupTextAreaContainer: {
    padding: 8,
    width: ({ textFieldWidth }) => textFieldWidth || 'unset',
  },
  textArea: {
    margin: 0,
  },
});

export const ActionCell = ({ row }) => {
  const { id, deleteRow } = row;
  return (
    <div style={{ paddingTop: 10 }}>
      <IconButton onClick={() => deleteRow(id)}>
        <Trash />
      </IconButton>
    </div>
  );
};

export const FieldCell = ({ row, column: { accessor: key } }) => {
  const classes = useStyles();

  const { handleOpenTablePropertiesModal, translatedFieldName, labelToDisplay } = row;

  const [inputValue, setInputValue] = useState(
    key === 'field' ? translatedFieldName : labelToDisplay
  );

  useEffect(() => {
    setInputValue(key === 'field' ? translatedFieldName : labelToDisplay);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [translatedFieldName, labelToDisplay]);

  const icon = key === 'field' ? <SearchIcon color="primary" /> : <EllipsisHorizontal />;

  return (
    <>
      <Tooltip
        extraLabels={[
          { title: '', subtitle: '' },
          { title: '', subtitle: row[key] },
        ]}
        placement="bottom"
        variant="light"
      >
        <TextField
          size="small"
          fullWidth
          label=""
          value={inputValue || ''}
          icon={icon}
          className={classes.field}
          inputProps={{
            readOnly: true,
            className: classes.input,
          }}
          iconProps={{
            onClick: () => handleOpenTablePropertiesModal(key, row),
            size: 'small',
            'ui-ta': getUITA('Modal open button'),
          }}
          ui-ta={getUITA('Selected Field')}
        />
      </Tooltip>
    </>
  );
};
